import {
  URL_ACCOUNT_TEAM,
  URL_CANDIDATES,
  URL_COPY_JOB,
  URL_CREATE_NEW_JOB,
  URL_CREATE_MULTI_LOCATION_JOB,
  URL_EDIT_DRAFT,
  URL_EDIT_JOB,
  URL_GLOBAL_JOB_DETAILS_EXPIRED,
  URL_GLOBAL_JOB_DETAILS_OPEN,
  URL_REFRESH_JOB,
  URL_UPGRADE_JOB,
} from '@seek/adv-constants';
import { siteNames } from '@seek/melways-sites';

import type { EmployerSiteName, Job } from 'src/types';
import { log } from 'src/utils/logging';

// Candidate Management
export const USER_MANAGEMENT = URL_ACCOUNT_TEAM;
export const FACEBOOK_SOCIAL_SHARE = 'http://www.facebook.com/sharer.php?u=';
export const TWITTER_SOCIAL_SHARE = 'http://twitter.com/share?url=';
export const LINKEDIN_SOCIAL_SHARE =
  'http://www.linkedin.com/shareArticle?mini=true&url=';

export const createJobAdPath = (job: Job, ref?: string) => {
  const basePath =
    job.status === 'EXPIRED'
      ? URL_GLOBAL_JOB_DETAILS_EXPIRED
      : URL_GLOBAL_JOB_DETAILS_OPEN;
  const fullPath = `${basePath}/${job.jobId}`;
  return ref ? `${fullPath}?ref=${ref}` : fullPath;
};

export const createMultiLocationPath = (job: Job, seekAdvertiserId: string) =>
  `${URL_CREATE_MULTI_LOCATION_JOB}?advertiserId=${seekAdvertiserId}&jobId=${job.jobId}`;

export const createCandidateManagementLink = (jobId: string) =>
  `${URL_CANDIDATES}/?jobid=${jobId}`;

export const createEditDraftJobLink = (draftId: string) =>
  `${URL_EDIT_DRAFT}&draftId=${draftId}`;
export const createRefreshLink = (job: Job) =>
  `${URL_REFRESH_JOB}?jobId=${job.jobId}`;
export const createEditLink = (job: Job) =>
  `${URL_EDIT_JOB}?jobId=${job.jobId}`;
export const createCopyLink = (job: Job) =>
  `${URL_COPY_JOB}&jobId=${job.jobId}`;
export const createCAJALink = () => URL_CREATE_NEW_JOB;
export const createUpgradeLink = (job: Job) =>
  `${URL_UPGRADE_JOB}/${job.jobId}?ref=hirer-jobs-list`;

export const createFacebookShareLink = (jobAdUrl: string) =>
  `${FACEBOOK_SOCIAL_SHARE}${encodeURIComponent(
    jobAdUrl,
  )}&t=We+are+recruiting+for+the+below+role`;

export const createLinkedInShareLink = (jobAdUrl: string) =>
  `${LINKEDIN_SOCIAL_SHARE}${encodeURIComponent(jobAdUrl)}`;

export const createTwitterShareLink = ({
  jobTitle,
  jobAdUrl,
  site,
}: {
  jobTitle: string;
  jobAdUrl: string;
  site: EmployerSiteName;
}) => {
  const baseUrl = `${TWITTER_SOCIAL_SHARE}${encodeURIComponent(
    jobAdUrl,
  )}&text=We+are+recruiting+for+a+${encodeURIComponent(jobTitle)}&via=`;
  switch (site) {
    case siteNames.employer.seek.au:
      return `${baseUrl}seekjobs`;
    case siteNames.employer.seek.nz:
      return `${baseUrl}seekjobsnz`;
    case siteNames.employer.seek.id:
    case siteNames.employer.seek.th:
    case siteNames.employer.seek.hk:
    case siteNames.employer.seek.my:
    case siteNames.employer.seek.ph:
    case siteNames.employer.seek.sg:
    default:
      log.warn(
        "links | createTwitterSareLink | Site not supported. Returning 'seekjobs' twitter user instead",
        {
          site,
          jobTitle,
          jobAdUrl,
        },
      );
      return `${baseUrl}seekjobs`;
  }
};
